<template>
    <div>
      <div class="d-flex flex-fill mb-2">
        <!-- 刷新 -->
        <a-button
          class="flex-shrink-0"
          :disabled="loading"
          @click="handleRefresh">
          <a-icon v-if="loading" type="sync" spin />
          <a-icon v-else type="sync" />
        </a-button>
        <actions
          :group="true"
          class="flex-shrink-0"
          :options="groupActions"
          button-type="default"
          :showSync="true"
          @clear-selected="() => $emit('clear-selected')" />
      </div>
      <vxe-grid
        v-bind="gridOptions"
        :columns="columns"
        row-key
        show-header-overflow
        highlight-hover-row
        highlight-current-row
        class="page-list-grid sortable-tree-demo"
        ref="grid"
        :tree-config="{children: 'children'}"
        @checkbox-change="checkboxChangeEvent"
        @checkbox-all="checkboxChangeEvent" />
      <div v-if="initData.length" class="mt-2 d-flex justify-content-end" style="font-size:12px">
        {{$t('common_717',[initData.length || 0])}}
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import DeleteResourceOwnerVue from '../../../../Cloudenv/views/projectmapping/dialogs/DeleteResourceOwner.vue'
import Actions from '@/components/PageList/Actions'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import DimensionMixin from '../mixins/dimension'

export default {
  name: 'DimensionItemList',
  components: {
    Actions,
  },
  mixins: [DimensionMixin, WindowsMixin, ListMixin],
  props: {
    id: String,
    data: Object,
    getParams: {
      type: Object,
    },
    domainList: Array,
    projectList: Array,
  },
  data () {
    return {
      gridOptions: {
        resizable: true,
        showOverflow: false,
        align: 'left',
        toolbarConfig: {
          slots: {
            buttons: 'toolbar_buttons',
          },
        },
        data: this.initData,
      },
      columns: [
        {
          type: 'checkbox',
          width: 40,
          showHeaderOverflow: false,
          resizable: false,
        },
        {
          field: 'name',
          title: this.$t('bill.text_289'),
        },
        {
          field: 'joint_id',
          title: this.$t('bill.text_300'),
          slots: {
            default: ({ row }) => {
              const dimensionItems = []
              if (row.dimension_type === 'domain') {
                row.dimension_domains.map(item => {
                  if (this.domainList.length) {
                    const domainList = this.domainList.filter(domain => {
                      return domain.id === item.domain_id
                    })
                    if (domainList[0]) {
                      dimensionItems.push(<span class="tag mb-1 text-truncate d-inline-block">{this.dimensionTag(domainList[0], 'domain')}</span>)
                    }
                  }
                })
              }
              if (row.dimension_type === 'resource_type') {
                row.dimensions_analysis.map(item => {
                  dimensionItems.push(<span class="tag mb-1 text-truncate d-inline-block">{this.dimensionTag(item, 'resource_type')}</span>)
                })
              }
              if (row.dimension_type === 'project') {
                row.dimension_projects.map(item => {
                  if (this.projectList.length) {
                    const projectList = this.projectList.filter(project => {
                      return project.id === item.project_id
                    })
                    if (projectList[0]) {
                      dimensionItems.push(<span class="tag mb-1 text-truncate d-inline-block">{this.dimensionTag(projectList[0], 'project')}</span>)
                    }
                  }
                })
              }
              if (row.dimension_type === 'bill') {
                row.dimensions_analysis.map(item => {
                  dimensionItems.push(<span class="tag mb-1 text-truncate d-inline-block">{this.dimensionTag(item, 'bill')}</span>)
                })
              }
              return dimensionItems
            },
          },
        },
        {
          field: '_action',
          title: this.$t('table.title._action'),
          minWidth: 120,
          resizable: false,
          slots: {
            default: ({ row }, h) => {
              return [
                this.$createElement(Actions, {
                  props: {
                    options: this.singleActions,
                    row,
                    buttonType: 'link',
                    buttonSize: 'small',
                    buttonStyle: {
                      fontSize: '12px',
                    },
                  },
                }),
              ]
            },
            header: ({ column }, h) => {
              return [
                this.$createElement('span', {
                  style: {
                    paddingLeft: '7px',
                  },
                }, this.$t('table.title._action')),
              ]
            },
          },
        },
      ],
      groupActions: [
        {
          label: this.$t('cloudenv.text_104'),
          permission: 'billsdimensions_update',
          group: true,
          action: () => {
            this.createDialog('DimensionItemSelectDialog', {
              id: this.data.id,
              dimension_type: this.data.dimension_type,
              excludeDimensionList: this.data.dimension_items || [],
              complate: (vm, values) => {
                this.addDimensionItemOpt(vm, values)
              },
            })
          },
          meta: () => {
            if (!(this.isAdminMode || this.data.domain_id === this.userInfo.projectDomainId)) {
              return {
                validate: false,
                tooltip: this.$t('cloudenv.text_597'),
              }
            }
            return {
              buttonType: 'primary',
            }
          },
        },
        {
          label: this.$t('cloudenv.text_108'),
          permission: 'billsdimensions_update',
          action: (row) => {
            this.createDialog('DimensionItemDeleteDialog', {
              data: this.checkedRecords,
              idKey: 'joint_id',
              columns: this.columns,
              title: this.$t('bill.text_303'),
              name: this.$t('bill.text_289'),
              onManager: this.onManager,
            })
          },
          meta: () => {
            const ret = {
              validate: true,
            }
            if (!this.checkedRecords.length) {
              ret.validate = false
            }
            if (!(this.isAdminMode || this.data.domain_id === this.userInfo.projectDomainId)) {
              ret.validate = false
              ret.tooltip = this.$t('cloudenv.text_597')
            }
            return ret
          },
        },
      ],
      singleActions: [
        {
          label: this.$t('cloudenv.text_593'),
          permission: 'billsdimensions_update',
          action: (row) => {
            this.createDialog('DimensionItemSelectDialog', {
              dimension_type: row.dimension_type,
              title: this.$t('cloudenv.text_598'),
              defaultDimensionData: row,
              excludeDimensionList: this.data.dimension_items.filter(item => item.joint_id !== row.joint_id), // 去除当前行的信息
              dimension_name: row.name,
              domainList: this.domainList,
              projectList: this.projectList,
              complate: (vm, data) => {
                this.modifyDimensionItemOpt(vm, data)
              },
            })
          },
          meta: () => {
            const ret = {
              validate: true,
            }
            if (!(this.isAdminMode || this.data.domain_id === this.userInfo.projectDomainId)) {
              ret.validate = false
              ret.tooltip = this.$t('cloudenv.text_597')
            }
            return ret
          },
        },
        {
          label: this.$t('cloudenv.text_108'),
          permission: 'billsdimensions_update',
          action: (row) => {
            this.createDialog('DimensionItemDeleteDialog', {
              data: [row],
              idKey: 'joint_id',
              columns: this.columns,
              title: this.$t('bill.text_303'),
              name: this.$t('bill.text_289'),
              onManager: this.onManager,
            })
          },
          meta: () => {
            const ret = {
              validate: true,
            }
            if (!(this.isAdminMode || this.data.domain_id === this.userInfo.projectDomainId)) {
              ret.validate = false
              ret.tooltip = this.$t('cloudenv.text_597')
            }
            return ret
          },
        },
      ],
      checkedRecords: [],
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope', 'isDomainMode', 'userInfo', 'l3PermissionEnable']),
    initData () {
      if (this.data) {
        return this.data.dimension_items ? this.data.dimension_items.map(item => {
          return Object.assign(item, { dimension_type: this.data.dimension_type })
        }) : []
      }
      return []
    },
  },
  watch: {
    data: {
      handler: function () {
        this.gridOptions.data = [...this.initData]
      },
      deep: true,
      immediate: true,
    },
  },
  created () {
    this.initSidePageTab('dimension-item-list')
  },
  methods: {
    doUpdate (id, data) {
      return new this.$Manager('dimensionjoints', 'v1').update({ id, data })
    },
    doCreate (id, data) {
      return new this.$Manager('billsdimensions', 'v1').performAction({ id, data, action: 'joint' })
    },
    async addDimensionItemOpt (vm, data) {
      // 名称重复判断
      if (this.data.dimension_items && this.data.dimension_items.some((item) => item.name === data.name)) {
        this.$message.error(this.$t('bill.text_296'))
        return
      }
      const params = {
        name: data.name,
        dimension_analysis_ids: [],
        dimensions_analysis: [],
        dimension_domains: [],
        dimension_projects: [],
      }
      data.tags.map(item2 => {
        if (this.data.dimension_type === 'bill') {
          params.dimension_analysis_ids.push(item2.id)
        } else if (this.data.dimension_type === 'resource_type') {
          params.dimensions_analysis.push({ brand: item2.brand, resource_type: item2.resource_type })
        } else if (this.data.dimension_type === 'domain') {
          params.dimension_domains.push({ domain_id: item2.id })
        } else if (this.data.dimension_type === 'project') {
          params.dimension_projects.push({ tenant_id: item2.id })
        }
      })
      await this.doCreate(this.data.id, params)
      this.$message.success(this.$t('bill.text_59'))
      this.$bus.$emit('DimensionListRefresh')
      vm.cancelDialog()
    },
    async modifyDimensionItemOpt (vm, data) {
      // 名称重复判断
      if (this.data.dimension_items && this.data.dimension_items.some((item) => item.name === data.name && item.id === data.id)) {
        this.$message.error(this.$t('bill.text_296'))
        return
      }
      const params = {
        name: data.name,
        dimension_id: this.data.id,
        dimension_item: {
          dimension_analysis_ids: [],
          dimensions_analysis: [],
          dimension_domains: [],
          dimension_projects: [],
        },
      }
      data.tags.map(item2 => {
        if (this.data.dimension_type === 'bill') {
          params.dimension_item.dimension_analysis_ids.push(item2.id)
        } else if (this.data.dimension_type === 'resource_type') {
          params.dimension_item.dimensions_analysis.push({ brand: item2.brand, resource_type: item2.resource_type })
        } else if (this.data.dimension_type === 'domain') {
          params.dimension_item.dimension_domains.push({ domain_id: item2.id })
        } else if (this.data.dimension_type === 'project') {
          params.dimension_item.dimension_projects.push({ tenant_id: item2.id })
        }
      })
      await this.doUpdate(data.id, params)
      this.$message.success(this.$t('bill.text_59'))
      this.$bus.$emit('DimensionListRefresh')
      vm.cancelDialog()
    },
    async deleteDimensionItem (data) {
      await new this.$Manager('dimensionjoints', 'v1').delete({ id: data.joint_id })
      this.$message.success(this.$t('bill.text_59'))
      this.$bus.$emit('DimensionListRefresh')
    },
    checkboxChangeEvent ({ records }) {
      this.checkedRecords = records
    },
    handleCustomList () {
      const grid = this.$refs.grid
      const cols = grid.getTableColumn().collectColumn || []
      let nameIndex = 0
      const hidenColumns = []
      if (cols.length) {
        const colType = cols[0].type
        nameIndex = colType === 'checkbox' ? 1 : 0
        hidenColumns.push(cols[nameIndex].property)
      }
      this.createDialog('CustomListDialog', {
        title: this.$t('common.text00011'),
        customs: grid.getTableColumn().collectColumn,
        hidenColumns,
      })
    },
    handleRefresh () {
      this.$bus.$emit('DimensionListRefresh')
    },
  },
}
</script>
<style lang="less" scoped>
.tag-list {
  min-height: 65px;
  border: 1px solid #ddd;
  padding: 8px;
}
.tag {
  max-width: 100%;
  line-height: 20px;
  margin-right: 10px;
  padding: 0 6px 0 4px;
  font-size: 12px;
  border-style: solid;
  border-width: 1px;
}
</style>
